<template>
  <div class="md-layout text-center login-fix-page" >
    <div class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100">
      <form @submit.prevent="validate">
        <login-card class="tm-login-form" _header-color="green">
          <h4 slot="title" class="title">
            Sign in
          </h4>
          <md-field class="form-group md-invalid" slot="inputs" style="margin-bottom: 28px">
            <md-icon>email</md-icon>
            <label>Email...</label>
            <md-input v-model="email" type="email"/>
            <validation-error :errors="apiValidationErrors.email"/>
          </md-field>
          <md-field class="form-group md-invalid" slot="inputs">
            <md-icon>lock_outline</md-icon>
            <label>Password...</label>
            <md-input v-model="password" type="password"/>
          </md-field>

          <md-field v-if="enableGrecaptcha"
                    class="form-group md-invalid grecapthca hide"
                    slot="inputs"
                    style="margin-bottom: 0"
                    :data-sitekey="this.key"
                    id="recaptcha1"
          >
          </md-field>
          <button
              v-if="!loading"
              slot="footer"
              type="submit"
              class="uk-button tm-button-primary uk-margin-bottom uk-position-relative"
              value="Submit">
            Login
          </button>
          <md-icon
              v-else
              id="loader"
              slot="footer"
              class="uk-margin-bottom">
            <v-progress-circular
                :width="2"
                indeterminate
                style="color: forestgreen"
            ></v-progress-circular>
          </md-icon>
        </login-card>
      </form>
    </div>
  </div>
</template>

<script>
import {LoginCard, ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
  components: {
    LoginCard, ValidationError
  },
  mixins: [formMixin],
  data: () => ({
    email: "",
    password: "",
    grecaptchaWidgetId: "",
    grecapthcaResult: "",
    loading: "",
    key: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
    enableGrecaptcha: process.env.NODE_ENV !== 'development',
    disableGrecaptchaEnabledip: false,
  }),
  async created() {
    await this.validateIp();
  },
  mounted() {
    if (this.enableGrecaptcha || !this.disableGrecaptchaEnabledip) {
      let recaptchaScript = document.createElement('script');
      recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js');
      document.head.appendChild(recaptchaScript);
    }
  },
  methods: {
    async validateIp(){
      window.axios = require('axios');
      const url = process.env.VUE_APP_API_BASE_URL;

      let response = await axios.post(url + '/grecaptcha_validate_status');
      if('data' in response && 'status' in response.data && response.data.status === true){
        this.disableGrecaptchaEnabledip = response.data.status;
      }
    },
    async validate() {
      if (!this.enableGrecaptcha || this.disableGrecaptchaEnabledip) {
        this.login();
      } else {
        if (this.grecaptchaWidgetId === "") {
          this.grecaptchaWidgetId = grecaptcha.render('recaptcha1');
          document.getElementById('recaptcha1').classList.remove('hide');
        } else {
          this.loading = true;
          if (grecaptcha.getResponse(this.grecaptchaWidgetId)) {
            window.axios = require('axios');
            const url = process.env.VUE_APP_API_BASE_URL;
            let recaptchaToken = grecaptcha.getResponse(this.grecaptchaWidgetId);
            let responce = await axios.post(url + '/grecaptcha_validate', {
              recaptcha_token: recaptchaToken
            })
            if (responce.data['success']) {
              this.grecapthcaResult = true
            }
            if (this.grecapthcaResult) {
              this.login();
            } else {
              alert('Проверка капчи провалилась!');
              this.loading = false;
            }
          } else {
            alert('Вы должны сначала пройти капчу!');
            this.loading = false;
          }
        }
      }
    },
    async login() {
      const user = {
        data: {
          type: "token",
          attributes: {
            email: this.email,
            password: this.password
          }
        }
      }
      const requestOptions = {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      }
      try {
        await this.$store.dispatch("login", {user, requestOptions});
        localStorage.setItem('start_time', Date.now());
      } catch (e) {
        if (e.response.data.errors) {
          Object.keys(e.response.data.errors).forEach(field => {
            const messages = e.response.data.errors[field];
            messages.forEach(message => {
              this.$store.dispatch("alerts/error", "Incorrect authorization data: " + message);
            });
          });
        } else {
          await this.$store.dispatch("alerts/error", "Error: " + e.message);
        }
      }
      this.loading = false;
    }
  }
};
</script>
<style scoped>
.login-fix-page {
  padding-bottom: 7em;
  padding-top: 4em;
}

.hide {
  display: none;
}
</style>

